<vdr-card>
  <vdr-form-field [label]="'Display Header Message'" class="mb-2">
    <input type="checkbox" clrToggle [formControl]="displayHeaderMessageControl" />
  </vdr-form-field>

  <vdr-form-field>
    <vdr-rich-text-editor [label]="'Copyright Notice'" [formControl]="copyrightNoticeControl"></vdr-rich-text-editor>
  </vdr-form-field>

  <vdr-form-field>
    <vdr-rich-text-editor [label]="'Disclaimer'" [formControl]="disclaimerControl"></vdr-rich-text-editor>
  </vdr-form-field>

  <vdr-form-field [label]="'Product Info Assets Carousel Arrow Type'">
    <select [formControl]="pdpAssetsArrowTypeControl">
      <option value="large-chevron">Large Chevron</option>
      <option value="chevron">Chevron</option>
      <option value="arrow">Arrow</option>
      <option value="small-arrow">Small Arrow</option>
      <option value="caret">Caret</option>
      <option value="none">None</option>
    </select>
  </vdr-form-field>

  <vdr-form-field [label]="'Mobile Buy Banner Type'">
    <select [formControl]="mobileBuyBannerTypeControl">
      <option value="regular">Regular</option>
      <option value="hide-msrp">Hide MSRP</option>
    </select>
  </vdr-form-field>
</vdr-card>
